<template>
  <div class="user-switch-modal">
    <modal-frame :showModalFlag="switchUserModalDisplay" :position="'low'" v-on:backdropClickEvent="closeModal">
      <div class="modal-body">
        <div
          class="selectable-users"
          v-for="user in availableUsers"
          :key="'switch' + user.id"
          @click="userSelected(user)">
          <div class="user-selected-marker">
            <img src="/images/check_icon.png" v-show="currentUser.id === user.id"/>
          </div>
          <div class="user-name">
            {{ user.name }}
          </div>
        </div>
      </div>
    </modal-frame>
  </div>
</template>

<script>
import ModalFrame from '@/components/common/ModalFrame.vue'

export default {
  name: 'UserSwitchModal',

  components: {
    ModalFrame
  },

  props: {
    currentUser: Object,
    availableUsers: Array,
    switchUserModalDisplay: Boolean
  },

  emits: [
    'userSelectedEvent',
    'cancelEvent'
  ],

  methods: {
    userSelected (user) {
      this.$emit('userSelectedEvent', user)
    },

    closeModal () {
      this.$emit('cancelEvent')
    },

    isCurrent (user) {
      if (user === this.currentUser) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.user-switch-modal {
  margin: 0;
  .modal-body {
    .selectable-users {
      display: flex;
      align-items: center;
      min-height: 50px;
      border-bottom: 1px solid #ddd;
      .user-selected-marker {
        width: 32px;
        padding: 5px 10px;
      }
      .user-name {
        font-size: 21px;
      }
    }
  }
}
</style>